import State from 'store/State';
import { WidgetType } from 'widgets/WidgetType';
import { selectWidgetInstancesState } from 'widgets/store/selectors';
import { ExpertiseWidgetsState } from './ExpertiseWidgetState';

export const selectExpertiseState: (
    state: State,
    widgetType: WidgetType
) => ExpertiseWidgetsState = (state, widgetType) =>
    widgetType === WidgetType.EXPERTISE_MAKE
        ? selectWidgetInstancesState(state).expertiseMake
        : selectWidgetInstancesState(state).expertiseNighthawk;

export const selectExpertiseWidgetState = (
    state: State,
    widgetType: WidgetType,
    widgetKey: string
) => selectExpertiseState(state, widgetType)[widgetKey];
